import { Component, inject, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TitleService } from './core/service/title-service/title.service';
import { ResponsiveTableService } from './core/service/responsive-table/responsive-table.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private titleService = inject(TitleService);
  private responsiveTables = inject(ResponsiveTableService);

  ngOnInit(): void {
    this.responsiveTables.start();
    // Clear the page title on every navigation so a page without its own
    // setPageTitle() does not inherit the previous page's title.
    this.router.events
      .pipe(filter((e) => e instanceof NavigationStart))
      .subscribe(() => this.titleService.clearPageTitle());
  }
}
